var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1583_15335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.58728 11.3951L9.87151 18.6782C10.2649 19.0725 10.9034 19.0725 11.2978 18.6782L18.5811 11.3951C18.7701 11.206 18.8763 10.9495 18.8763 10.682C18.8763 10.4146 18.7701 10.1581 18.5811 9.96893L11.2978 2.68585C11.1086 2.49681 10.8521 2.39062 10.5846 2.39062C10.3172 2.39062 10.0607 2.49681 9.87151 2.68585L2.5882 9.96893C2.39916 10.1581 2.29297 10.4146 2.29297 10.682C2.29297 10.9495 2.39916 11.206 2.5882 11.3951H2.58728Z",
    stroke: "white",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.26953 10.6875H13.9029",
    stroke: "white",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5859 7.36719L13.9026 10.6839L10.5859 14.0005",
    stroke: "white",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_15335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9,
    height: 19.9,
    fill: "white",
    transform: "translate(0.634766 0.734375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.1d4366649cdeb910fcb034a0c04fd21a.svg";
export { ForwardRef as ReactComponent };